var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ThreejsContainer',{staticClass:"space-droid-viewport"},[_c('div',{ref:"space_droid",staticClass:"space-droid"})])}
var staticRenderFns = []

export { render, staticRenderFns }